@if (!entryFormWorking()) {
  <form [formGroup]="entryForm" (ngSubmit)="saveEntry()" class="form">
    <div class="panel">
      <div class="form-body">
        <span class="label"
          >{{ 'COMMERCIAL_SERVICES.LABEL.NOTE' | translate }}:</span
        >
        <app-note-editor formControlName="entryText" />
      </div>

      <div class="modal-buttons">
        <button
          pButton
          type="submit"
          label="{{ 'COMMON.LABEL.BUTTONS.OK' | translate }}"
          icon="fa fa-fw fa-check"
          [disabled]="!entryForm.valid"
        ></button>
        <button
          pButton
          type="button"
          label="{{ 'COMMON.LABEL.BUTTONS.CANCEL' | translate }}"
          icon="fa fa-fw fa-ban"
          (click)="cancel()"
        ></button>
      </div>
    </div>
  </form>
} @else {
  <app-progress-spinner [enabled]="entryFormWorking()" />
}
